module.exports = __webpack_public_path__ + "static/media/gif.6f2789e0.svg";